// extracted by mini-css-extract-plugin
export default {"view":"PendingRequestsGrid_view__hteKy"};